import { render, staticRenderFns } from "./TicketsHistoryList.vue?vue&type=template&id=02b25960&scoped=true"
import script from "./TicketsHistoryList.vue?vue&type=script&lang=js"
export * from "./TicketsHistoryList.vue?vue&type=script&lang=js"
import style0 from "./TicketsHistoryList.vue?vue&type=style&index=0&id=02b25960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b25960",
  null
  
)

export default component.exports